"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COUNTRY_CODE = exports.DEFAULT_TIMEZONE = void 0;
exports.DEFAULT_TIMEZONE = 'Australia/Sydney';
exports.DEFAULT_COUNTRY_CODE = 'AU';
//# sourceMappingURL=timezone.js.map